import { useSelector } from '@xstate/react';
import { Navigate, useLocation } from 'react-router';
import type { ActorRefFrom } from 'xstate';
import { readRegistrationReturnTo } from '~/routing/registrationReturnTo';
import { buildAuthCompletePath } from '~/routing/returnTo';
import { employerRegistrationView } from '../registration-view.machine';

interface PageProps {
  actorRef: ActorRefFrom<typeof employerRegistrationView>;
}

// ==================== Registration Complete Page ====================

export function RegistrationCompletePage({ actorRef }: PageProps) {
  // Detect when the service has completed - parent state should transition to authenticatedProvider
  const location = useLocation();
  const isCompleted = useSelector(actorRef, (state) => state.matches('$_COMPLETED'));

  if (isCompleted) {
    return (
      <Navigate to={buildAuthCompletePath(readRegistrationReturnTo(location.search))} replace />
    );
  }

  return (
    <div className="registration-page complete">
      <div className="success-message">
        <svg className="success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l4 4L19 7" />
        </svg>
        <h1>Registration Complete!</h1>
        <p>Welcome, {'Employer'}!</p>
        <p>Your provider registration has been successfully submitted.</p>
      </div>
    </div>
  );
}
